const state = {
  averages: {
    gas: [
      { label: 'Low Usage', value: 6000 },
      { label: 'Medium Usage', value: 9500 },
      { label: 'High Usage', value: 14000 }
    ],
    electricity01: [
      { label: 'Low Usage', value: 1600 },
      { label: 'Medium Usage', value: 2500 },
      { label: 'High Usage', value: 3800 }
    ],
    electricity02: [
      { label: 'Low Usage', value: 1900 },
      { label: 'Medium Usage', value: 3400 },
      { label: 'High Usage', value: 6100 }
    ]
  }
};

const getters = {
  averages: (state, getters, rootState, rootGetters) => {
    const quoteType = rootGetters['quote/quoteType'];
    const is02Meter = rootGetters['quote/is02Meter'];

    if (quoteType == 'gasToGas') {
      return state.averages.gas;
    }

    if (is02Meter) {
      return state.averages.electricity02;
    }

    return state.averages.electricity01;
  }
};

const actions = {};

const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
